import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="hero">
      <div className="container hero-content">
        <div>
          <p className="hero-tagline">
            Hi, I’m <span>Pavan</span>
          </p>
          <h1>Developer Portfolio</h1>
          <p className="hero-subtitle">
            I’m a developer who enjoys designing and building small, focused applications
            hosted on the cloud using the pavant.dev domain.
          </p>
          <div className="hero-actions">
            <Link to="/projects" className="btn primary">
              View Projects
            </Link>
            <Link to="/contact" className="btn ghost">
              Contact Me
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
